export default __webpack_public_path__ + "static/media/eject.8d92f02d.svg";